<template>
    <div>
        <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{x: true}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
      <CentralHeatingCommand-modal ref="modalForm" @ok="modalFormOk"></CentralHeatingCommand-modal>
    </div>
</template>
<script>
import CentralHeatingCommandModal from './CentralHeatingCommandModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import {isUndefined} from'@/utils/validate'
import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'
import {meterTypeObj} from '@/utils/constants/commonConstant'

export default {
    props: {
        queryParentParam: Object,
    },
    mixins:[JeecgListMixin],
    components: {
        CentralHeatingCommandModal,
    },
    data() {
        return {
            meterTypeObj,
            url: {
                list: "/central/meterNthCommand/list",
                exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls"
            },
        }
    },
    computed: {
        // i18n：表头使用 computed 以响应语言切换
        columns() {
            return [
                {
                    title: '#',
                    dataIndex: '',
                    key:'rowIndex',
                    width:60,
                    align:"center",
                    customRender:(t,r,index) => {
                    return parseInt(index)+1;
                    }
                },{
                    title: this.$t('命令类型'),
                    align:"center",
                    dataIndex: 'cmd',
                    customRender:(text) => {
                    return this.$t(dataFlagObj[text])
                    }
                },{
                    title: this.$t('表类型'),
                    align:"center",
                    dataIndex: 'meterType',
                    customRender:(t,r,index) => {
                        let data = meterTypeObj
                        if(isUndefined(data[t])) {
                            return this.$t("其他")
                        }
                        return this.$t(data[t])
                    }
                },{
                    title: this.$t('表编号'),
                    align:"center",
                    dataIndex: 'meterId'
                },{
                    title: this.$t('发送状态'),
                    align:"center",
                    dataIndex: 'status',
                    customRender:(t,r,index) => {
                    if(isUndefined(reportStatusObj[t])) {
                        return this.$t("其他")
                    }
                    return this.$t(reportStatusObj[t])
                    }
                },{
                    title: this.$t('发送时间'),
                    align:"center",
                    dataIndex: 'sendTime'
                },{
                    title: this.$t('接收回应时间'),
                    align:"center",
                    dataIndex: 'receiveTime'
                },/*{
                    title: '指令标记帧',
                    align:"center",
                    dataIndex: 'mid'
                },*/{
                    title: this.$t('操作'),
                    dataIndex: 'action',
                    align:"center",
                    flex: "right",
                    width: 147,
                    scopedSlots: { customRender: 'action' },
                }
            ]
        },
    },
    methods: {
        loadData(arg) {
            if(!this.url.list){
                this.$message.error(this.$t("请设置url.list属性!"))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
                this.ipagination.current = 1;
            }
            var params = this.getQueryParams();//查询条件
            params = Object.assign(params, this.queryParentParam);
            console.log(params)
            this.loading = true;
            getAction(this.url.list, params).then((res) => {
                if (res.success) {
                this.dataSource = res.result.records;
                this.ipagination.total = res.result.total;
                }
                if(res.code===510){
                this.$message.warning(res.message)
                }
                this.loading = false;
            })
        }
    }
}
</script>